export default __webpack_public_path__ + "static/media/Akash.c2f14b1b.jpeg";